// JsFromRoutes CacheKey 9f2cbc638dbe68e2cfc6efe2e4074fc2
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/sales_reps'),
  create: /* #__PURE__ */ definePathHelper('post', '/api/workspace/:venue_slug/sales_reps'),
  new: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/sales_reps/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/sales_reps/:id/edit'),
  show: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/sales_reps/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/api/workspace/:venue_slug/sales_reps/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/api/workspace/:venue_slug/sales_reps/:id'),
}
